/**
 *
 * QualitativeQuestion
 *
 */

import React, { Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { Link } from "react-router-dom"
import { Select, Empty } from "antd"
import { isEqual, isEmpty, uniqBy, omit } from "lodash"
import QualitativeQuestionList from "../../../QualitativeQuestionList"
import empty_meditions from "../../../../../images/emptyQuestionsReports.svg"
import iconPencil from "../../../../../images/icon-pencil.svg"
import "./index.less"
import { QUALITATIVE_FEEDBACK } from "../../../../../utils/constants"
import { isModeInModuleBySlug } from "../../../../../utils/storage"
import { validate } from "../../../../../utils/functions"
import { loadTexts } from "../../../../../utils/i18n"
import { PageView } from "../../../../../components/Snowplow/config2"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class QualitativeQuestion extends React.Component {
  intlWidgetQualitativeQuestion = loadTexts("reports_general_view")
    .reportAmbassador.engagementMeasurement.widgetQualitativeQuestion

  state = {
    selectedFilter: null,
    totalAnswers: 0,
    questionsList: [],
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.questions, nextProps.questions)) {
      this.setState({
        selectedFilter:
          nextProps.questions.length > 0
            ? nextProps.questions[0].id_question
            : null,
      })
    }
  }

  componentDidMount() {
    const { questions, onlyQuestions } = this.props
    this.setState({
      selectedFilter:
        this.props.onlyQuestions.length > 0
          ? this.props.onlyQuestions[0].id_question
          : null,
    })
    if (validate.exist(onlyQuestions) && !validate.empty(onlyQuestions)) {
      let questionsList = uniqBy(onlyQuestions, (e) => e.id_question)
      this.setState({ questionsList })
    }
  }

  render() {
    const { selectedFilter, totalAnswers, questionsList } = this.state
    const {
      measure,
      questions,
      onlyQuestions,
      pagination,
      selectedSegment,
      ambassadorDivisionSelected,
    } = this.props

    const isQualitativeFeedbackModule = isModeInModuleBySlug(
      QUALITATIVE_FEEDBACK
    )

    let parentDivision = ""
    if (this.props.parentId !== null) {
      const searchLocation = getUrlParams(location.search)
      let paramsPath = { ...searchLocation }
      parentDivision =
        isEmpty(paramsPath.id_divisionParent) ||
          paramsPath.id_divisionParent === undefined ||
          paramsPath.id_divisionParent === "undefined"
          ? isEmpty(this.props.parentId) ||
            this.props.parentId === undefined ||
            this.props.parentId === "undefined"
            ? ""
            : `&id_divisionParent=${this.props.parentId}`
          : `&id_divisionParent=${paramsPath.id_divisionParent}`
    }

    let isAmbassador = ""
    if (validate.exist(this.props.isAmbassador)) {
      isAmbassador = this.props.isAmbassador
    }

    let segmentParams = ""
    if (!validate.empty(selectedSegment)) {
      segmentParams =
        parentDivision === "" && isAmbassador === ""
          ? `?id_segment=${selectedSegment}`
          : `&id_segment=${selectedSegment}`
    }

    return (
      <div
        className="boxShadow QualitativeQuestion"
        style={{ marginTop: "1.2rem" }}>
        <h4>
          <img src={iconPencil} alt="icon-pencil" style={{ marginRight: 5 }} />
          {this.intlWidgetQualitativeQuestion.title}
        </h4>
        {Array.isArray(onlyQuestions) && questions.length > 0 ? (
          <Fragment>
            <div className="QualitativeQuestion-total">
              {`${totalAnswers} ${this.intlWidgetQualitativeQuestion.answers}`}
            </div>
            <div className="QualitativeQuestion">
              <div className="QualitativeQuestion-header">
                <div className="QualitativeQuestion-header-btn-link">
                  <span>
                    {isQualitativeFeedbackModule ? (
                      this.props.isMeasure ? (
                        <Link
                          onClick={() =>
                            PageView(
                              "Preguntas cualitativas - Ver todas las respuestas", null,
                              null
                            )
                          }
                          to={`/models/measure/${measure}/qualitative-question`}>
                          {this.intlWidgetQualitativeQuestion.link}
                        </Link>
                      ) : (
                        <Link
                          onClick={() =>
                            PageView(
                              "Preguntas cualitativas - Ver todas las respuestas", null,
                              null
                            )
                          }
                          to={`/reports/measure/${measure}/qualitative-question${isAmbassador}${parentDivision}${segmentParams}`}>
                          {this.intlWidgetQualitativeQuestion.link}
                        </Link>
                      )
                    ) : null}
                  </span>
                </div>
              </div>
              <div style={{ marginTop: 20 }}>
                <Select
                  showSearch
                  optionFilterProp="id"
                  value={selectedFilter || undefined}
                  onChange={(s) => {
                    this.setState({ selectedFilter: s })
                  }}
                  style={{ width: 350 }}>
                  {onlyQuestions.map((f, i) => (
                    <Option id={f.id_question} key={i} value={f.id_question}>
                      {f.name}
                    </Option>
                  ))}
                </Select>
              </div>
              <QualitativeQuestionList
                total={6}
                pagination={pagination}
                measure={measure}
                totalAnswers={(t) => this.setState({ totalAnswers: t })}
                question={selectedFilter}
                ambassadorDivisionSelected={ambassadorDivisionSelected}
                selectedSegment={selectedSegment}
              />
            </div>
          </Fragment>
        ) : (
          <div className="QualitativeQuestion">
            <Empty
              style={{ color: "#828282" }}
              image={empty_meditions}
              description={
                <span
                  style={{ margin: "0 auto", maxWidth: 440, display: "block" }}>
                  {this.intlWidgetQualitativeQuestion.empty}
                </span>
              }
              className="ReportsHome-empty-fix"
            />
          </div>
        )}
      </div>
    )
  }
}

QualitativeQuestion.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(QualitativeQuestion)
